export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6i-ab4c3284b4b0947748a8173d5e61d900.webp";